export const UNIT_SCALE_RANGE: [number, number] = [1, 1000]

export const energyToPowerUnit = (energyUnit: string | null | undefined): string => {
  if (!energyUnit) return 'kW' // default

  switch (energyUnit) {
    case 'kWh':
      return 'kW'
    case 'm3':
      return 'm³/h'
    default:
      return 'kW'
  }
}

/**
 * Given a value, this method will figure out how to get the number into the desired targetValueRange.
 * e.g. you have 0.5 kWh and you want to scale it between 100 and 10000 for visual purposes.
 * This then will return: {
 *  targetUnit: Wh
 *  multiplier: 1000
 * }
 */
export const scaleUnitToTargetValue = (value: number, unit: string, targetValueRange: [number, number]) => {
  if (value === 0 || unit === 'EUR') {
    return {
      targetUnit: unit,
      scaler: 1,
    }
  }
  const multiplierStep = ['m', '', 'k', 'M', 'G', 'T']
  const baseUnit = unit.endsWith('Wh') ? 'Wh' : 'W'
  const multiplierPrefix = unit.slice(0, unit.length - baseUnit.length)
  const [minThreshold, maxThreshold] = targetValueRange

  let step = 0
  if (value < minThreshold) {
    step = scaleNumberUp(value, maxThreshold)
  } else if (value > maxThreshold) {
    step = scaleNumberDown(value, maxThreshold)
  }

  const targetMultiplerIndex = multiplierStep.indexOf(multiplierPrefix) + step
  const targetMultipler = multiplierStep[targetMultiplerIndex]
  const scaler = Math.pow(1000, -step)

  return {
    targetUnit: `${targetMultipler}${baseUnit}`,
    scaler,
  }
}

const scaleNumberUp = (val: number, maxValue: number, step = 0) => {
  if (val > maxValue) return step + 1
  return scaleNumberUp(val * 1000, maxValue, step - 1)
}

const scaleNumberDown = (val: number, maxValue: number, step = 0) => {
  if (val < maxValue) return step
  return scaleNumberDown(val / 1000, maxValue, step + 1)
}
